import { combineReducers } from 'redux';
import * as types from 'store/types';

// IMPORT COMMON REDUCERS
import auth from './auth';
import searchCars from './searchCars';
import carDetail from './carDetail';
import booking from './booking';
import airport from './airport';
import configuration from './configuration';

const appReducer = combineReducers({
	auth,
	searchCars,
	carDetail,
	booking,
	airport,
	configuration
});

const rootReducer = (state, action) => {
	if (action.type === types.AUTH_SIGN_OUT_SUCCESS) {
		state = { configuration: state.configuration };
	}

	return appReducer(state, action);
};

export default rootReducer;
